// extracted by mini-css-extract-plugin
export default {"Modal":"ModalTour_Modal__G54-d"};